module.exports = __webpack_public_path__ + "static/media/our-services-people.335d498b.jpg";